/**
 * 「升级提示」只展示一次的本地标记。
 *
 * 某个钱包成功导入过一次助记词后写入标记，之后（关掉窗口重新打开）
 * 直接进入下一步，不再重复展示升级提示。
 *
 * 存储用 localStorage：WebView 侧已开启 DOM storage，且数据目录固定，
 * 关窗/重开、甚至 App 重启后标记都还在。存储不可用时静默降级为「每次都显示」。
 */
const STORAGE_KEY = 'wallet_upgrade_done_v1';

function normalizeKey(walletKey) {
	const key = String(walletKey == null ? '' : walletKey)
		.trim()
		.toLowerCase();
	return key || 'default';
}

function readAll() {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		const parsed = raw ? JSON.parse(raw) : null;
		return parsed && typeof parsed === 'object' ? parsed : {};
	} catch (_) {
		return {};
	}
}

function writeAll(map) {
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
	} catch (_) {
		/* 隐私模式 / 存储被禁用：忽略，退回每次显示升级提示 */
	}
}

/** 该钱包是否已经成功导入过 */
export function isUpgradeDone(walletKey) {
	return !!readAll()[normalizeKey(walletKey)];
}

/** 记录该钱包已成功导入 */
export function markUpgradeDone(walletKey) {
	const key = normalizeKey(walletKey);
	const map = readAll();
	if (!map[key]) {
		map[key] = Date.now();
		writeAll(map);
	}
}

/** 清除标记：不传钱包名清空全部（调试用） */
export function resetUpgradeDone(walletKey) {
	const map = readAll();
	if (walletKey == null) {
		writeAll({});
		return;
	}
	delete map[normalizeKey(walletKey)];
	writeAll(map);
}
